module.exports = __webpack_public_path__ + "img/RO.9bd8fff8.svg";